import type { Space, SpaceImage, SpaceType } from '@interfaces/space.interface';

import { SPACE_NAMES, SPACE_TYPE_DATA } from '../pools';
import { pickAt, randomBool, randomInt, uuid } from '../utils';

const IMAGES_PER_SPACE = [2, 3, 4, 2, 3, 4, 2, 3];

function buildSpaceImages(spaceIndex: number, count: number): SpaceImage[] {
  return Array.from({ length: count }, (_, i) => {
    const seed = `space-${spaceIndex}-img-${i}`;
    return {
      id: uuid(),
      url: `https://picsum.photos/seed/${seed}/800/600`,
      title: `Photo ${i + 1}`,
      description: `Space photo ${i + 1}`,
      index: i,
    };
  });
}

export function buildSpaceTypes(): SpaceType[] {
  return SPACE_TYPE_DATA.map(st => ({
    id: uuid(),
    name: st.name,
    description: st.description,
  }));
}

export function buildSpace(
  spaceTypes: SpaceType[],
  index: number,
  overrides?: Partial<Space>
): Space {
  const spaceType = pickAt(spaceTypes, index);
  return {
    id: uuid(),
    name: pickAt(SPACE_NAMES, index),
    description: `${spaceType.name} area with great amenities`,
    typeId: spaceType.id,
    spaceType,
    maxOccupancy: randomInt(1, 8),
    area: randomInt(12, 60),
    floor: randomInt(0, 3),
    available: randomBool(0.9),
    images: buildSpaceImages(index, IMAGES_PER_SPACE[index % IMAGES_PER_SPACE.length]),
    ...overrides,
  };
}

export function buildSpaces(count: number, spaceTypes: SpaceType[]): Space[] {
  return Array.from({ length: count }, (_, i) => buildSpace(spaceTypes, i));
}
